import React from 'react'
import styles from "./DoctorQrCodeModal.module.css";
import QRCode from "qrcode.react";

const CLOSE_ICON = process.env.PUBLIC_URL + "/images/close-icon.png";

interface DoctorQrCodeModalProps extends React.PropsWithChildren {
  title: string;
  qrValue: string;
  description: string;
  onClose(): void;
  isShow: boolean;
}

const DoctorQrCodeModal: React.FC<DoctorQrCodeModalProps> = ({
  title,
  qrValue,
  description,
  isShow = false,
  onClose
}) => {
  return (
    <>
      {
        isShow &&
        <div className={styles.wrap}>
          <div className={styles.container}>
            <div className={styles.modalContainer}>
              <div className={styles.header}>
                <span style={{ fontSize: 26 }}>{title}</span>
                <img onClick={onClose} src={CLOSE_ICON} alt="CLOSE_ICON" width={20} style={{ position: "absolute", right: 0, marginRight: 38.25, marginTop: 8, cursor: "pointer"}}/>
              </div>
              <div className={styles.body}>
                <div style={{ padding: "51px 71px", display: "flex", flexDirection: "column", alignItems: "center"}}>
                  <QRCode
                    includeMargin={true}
                    size={380}
                    level="H" id="qr-gen"
                    style={{ borderRadius: 12 }}  
                    value={qrValue}
                    renderAs="canvas" 
                  />
                  <p style={{ textAlign: "center", fontSize: 23 }}>
                    {description}
                  </p> 
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default DoctorQrCodeModal